import { EXTERNAL_URLS } from '../../../routing/routes';

export class Venafi {
  constructor(private readonly url: string, private readonly accessToken: string, private readonly trustedCaCertificate: string | null) {}

  getUrl() {
    return this.url;
  }

  getAccessToken() {
    return this.accessToken;
  }

  getTrustedCaCertificate() {
    return this.trustedCaCertificate;
  }

  certificateViewUrl(guid: string) {
    return `${this.getUrl()}${EXTERNAL_URLS.VENAFI_VIEW_CERTIFICATE}{${guid}}`;
  }
}
